// extracted by mini-css-extract-plugin
module.exports = {"download-manager-list":"style_download-manager-list__3Whp5"};